import firebase from 'firebase/app'
import 'firebase/firestore'

const config = {
  apiKey: process.env.FIREBASE.API_KEY,
  authDomain: process.env.FIREBASE.AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE.DATABASE_URL,
  projectId: process.env.FIREBASE.PROJECT_ID,
  storageBucket: process.env.FIREBASE.STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE.MESSAGING_SENDER_ID
}

const firebaseApp = firebase.initializeApp(config, 'exercise-vue')
const firestore = firebaseApp.firestore()

export default firestore



// WEBPACK FOOTER //
// ./src/firebase/firestore.js